import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';

const pillars = [
  {
    icon: (
      <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    title: 'Fase de Preventa: El Set de Autoridad',
    subtitle: 'Entrevistas de alto impacto en sede. Los patrocinadores sienten el respaldo tecnológico de TNO Network desde el día uno.',
  },
  {
    icon: (
      <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Cobertura en Terreno: Yeraldine Marrero',
    subtitle: 'Host especialista que va a las canchas y conecta con directivos, coaches y participantes. Contenido humano, técnico y altamente compartible.',
  },
  {
    icon: (
      <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Visibilidad Multiplataforma TNO Network',
    subtitle: 'Rotativa publicitaria, TNO Digest y momentos On-Demand en la señal oficial del ecosistema — sin depender de un programa externo.',
  },
];

const AboutSection = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  return (
    <Box>
      <Box marginBottom={{ xs: 4, sm: 8, md: 10 }}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          gutterBottom
          color="primary"
          align="center"
        >
          About
        </Typography>
        <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
          El Respaldo: Ingeniería de Medios con Propósito
        </Typography>
        <Typography variant="h6" component="p" color="textSecondary" align="center" maxWidth={720} margin="0 auto">
          12 años transformando la comunicación digital. TNO Network no es solo un medio; es el ecosistema que cubre tu evento de pádel con la distinción, producción y alcance que un torneo de esta categoría merece.
        </Typography>
      </Box>
      <Grid container spacing={4} direction={isMd ? 'row' : 'column-reverse'}>
        <Grid item xs={12} md={6} data-aos={isMd ? 'fade-right' : 'fade-up'}>
          <Typography
            sx={{ textTransform: 'uppercase', fontWeight: 600 }}
            gutterBottom
            color="primary"
          >
            Pilares de la cobertura
          </Typography>
          <Typography variant="h5" fontWeight={700} gutterBottom>
            Preventa, terreno y ecosistema TNO
          </Typography>
          <List disablePadding>
            {pillars.map((item, index) => (
              <ListItem key={index} disableGutters sx={{ alignItems: 'flex-start' }} data-aos="fade-up">
                <ListItemAvatar>
                  <Box
                    component={Avatar}
                    variant="rounded"
                    bgcolor={`${theme.palette.primary.light}33`}
                    color={theme.palette.primary.dark}
                  >
                    {item.icon}
                  </Box>
                </ListItemAvatar>
                <ListItemText
                  primary={item.title}
                  secondary={item.subtitle}
                  primaryTypographyProps={{ fontWeight: 600 }}
                />
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid item xs={12} md={6} container justifyContent="center" alignItems="center" data-aos={isMd ? 'fade-left' : 'fade-up'}>
          <Box
            component={Card}
            boxShadow={4}
            borderRadius={2}
            overflow="hidden"
            sx={{ bgcolor: theme.palette.alternate.main }}
          >
            <Box p={3}>
              <Typography variant="overline" color="primary" fontWeight={700}>
                Host especialista
              </Typography>
              <Typography variant="body2" color="primary" fontWeight={600} sx={{ mb: 0.5 }}>
                TNO Network · Cobertura oficial del evento
              </Typography>
              <Typography variant="h5" fontWeight={700} gutterBottom>
                Yeraldine Marrero
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                Host especialista respetada. Va a las canchas y conecta con directivos, coaches y participantes. No solo narra; genera contenido humano y de alto valor para marcas y evento.
              </Typography>
              <Typography variant="body2" fontWeight={700} color="primary">
                Más de 100K seguidores en Instagram · ${60}/día en terreno
              </Typography>
              <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                  Ventana oficial de cobertura
                </Typography>
                <Box
                  sx={{
                    height: 48,
                    width: 'auto',
                    maxWidth: 200,
                    mb: 1,
                    backgroundImage: 'url(/images/logos/logo_tnonetwork_black.png)',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'left center',
                    backgroundSize: 'contain',
                  }}
                />
                <Typography variant="h6" fontWeight={700} color="primary">
                  TNO Network
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  La cobertura del evento de pádel se realiza bajo la señal y el ecosistema de TNO Network: streaming, On-Demand, redes y TNO Digest.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AboutSection;
